export default __webpack_public_path__ + "static/media/Roles.4ec31dd2.png";